export default __webpack_public_path__ + "static/media/game.a940b57a.png";